import { instance, objectToParams } from './api';

export const listDeposits = () => instance.get(`/api/v1/deposits?limit=1000`);

export const listGroups = () => instance.get(`/api/v1/deposits?limit=1000&onlyGroups=true`);

export const getDeposits = (args) => instance.get(`/api/v1/deposits?${objectToParams(args)}`);

export const getDepositById = (id) => instance.get(`/api/v1/deposits/${id}`);

export const getDepositByIdStock = (id, args) => instance.get(`/api/v1/deposits/${id}/stock?${objectToParams(args)}`);

/**
 * Stock conjunto de varios depósitos (vista multidepósito).
 * `args.deposits` es un array de ids o el string '1:2:3'; `objectToParams` ya
 * serializa los arrays con la convención de dos puntos del back.
 * Acepta los mismos filtros que el listado de stock de un depósito.
 */
export const getMultiDepositStock = (args) => instance.get(`/api/v1/deposits/stock?${objectToParams(args)}`);

export const postNewDeposit = (data) => instance.post(`/api/v1/deposits`, data);

export const postAdjustment = (id, data) => instance.post(`/api/v1/deposits/${id}/adjustment`, data);

export const depositEdit = (id, data) => instance.put(`/api/v1/deposits/${id}`, data);

export const deleteDeposit = (id) => instance.delete(`/api/v1/deposits/${id}`);
